import React, { useEffect } from "react";
import { db, getDoc, doc } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const AdminCheck = () => {
  const { currentUser } = useAuth();
  let navigate = useNavigate();
  useEffect(() => {
    check();
  }, []);
  const check = async () => {
    const docRef = doc(db, "users", currentUser.uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if (
        docSnap.data().position === "admin" ||
        docSnap.data().position === "manager"
      ) {
        window.sessionStorage.setItem("position", docSnap.data().position);
      } else {
        console.log("position", docSnap.data().position);
        navigate(`/`);
      }
    } else {
      navigate(`/`);
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  };
  return <div></div>;
};

export default AdminCheck;
